module.exports = __webpack_public_path__ + "fonts/helvetica_light_oblique.7f23649.ttf";